// @flow

export type ActivityWorkableBacklogTypes = {
  GET_RATE_OF_PROGRESS: 'getWorkableBacklogWeekly',
  GET_RATE_OF_PROGRESS_SUCCESS: 'getWorkableBacklogWeeklySuccess',
  GET_RATE_OF_PROGRESS_FAIL: 'getWorkableBacklogWeeklyFail',
  GET_RATE_OF_PROGRESS_LOADING: 'getWorkableBacklogWeeklyLoading',
}

const actionTypes: ActivityWorkableBacklogTypes = {
  GET_RATE_OF_PROGRESS: 'getWorkableBacklogWeekly',
  GET_RATE_OF_PROGRESS_SUCCESS: 'getWorkableBacklogWeeklySuccess',
  GET_RATE_OF_PROGRESS_FAIL: 'getWorkableBacklogWeeklyFail',
  GET_RATE_OF_PROGRESS_LOADING: 'getWorkableBacklogWeeklyLoading',
};

export default actionTypes;
